import React from 'react';
import {
  reduxForm,
  Field,
  Form,
  FormSection,
  InjectedFormProps,
} from 'redux-form';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { makeStyles } from '@material-ui/core/styles';
import { errorParser } from 'utils/errorParser';
import Button from 'components/Button/Button';
import Fields from 'components/Fields';
import { useFormatMessage } from 'components/IntlProvider';

interface RespondentsToAcceptProps extends InjectedFormProps {
  initialValues: {
    rows: any;
  };
}

const useStyles = makeStyles({
  fieldsBox: {
    display: 'flex',
    alignItems: 'center',
  },
  btn: {
    marginTop: '2rem',
  },
});

const RespondentsToAccept = (props: RespondentsToAcceptProps) => {
  const t = useFormatMessage();
  const classes = useStyles();
  return (
    <Form onSubmit={props.handleSubmit}>
      {props.initialValues.rows.map(function (row: any) {
        return (
          <FormSection
            key={row.line_number}
            name={`newRows.${row.line_number}`}
            className={classes.fieldsBox}
          >
            <Field
              variant="outlined"
              margin="normal"
              checked={false}
              name="isCorrected"
              component={Fields.Checkbox}
            ></Field>
            <Field
              key={`${row.line_number}-input`}
              variant="outlined"
              margin="dense"
              fullWidth
              type="email"
              name="value"
              placeholder={row.field_value}
              component={Fields.Text}
            ></Field>
            <Tooltip title={errorParser(row.error)}>
              <InfoIcon />
            </Tooltip>
          </FormSection>
        );
      })}
      <Button
        className={classes.btn}
        isLoading={props.submitting}
        type="submit"
        variant="contained"
        color="primary"
      >
        {t('dashboard.respondendts.resend', 'Resend')}
      </Button>
    </Form>
  );
};

export default reduxForm({
  form: 'respondentsToAccept',
})(RespondentsToAccept);
